import { VideoService } from '../../services/video.service';
import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { EventManagerService } from 'event-manager';
import { WincoEvents } from 'src/app/enums/winco-events..enum';
import { environment } from 'src/environments/environment';

/**
 * Representa un reproductor vídeo
 */
@Component({
  selector: 'app-video-component',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit
{
  environment = environment;

  @Input() poster: string | undefined;
  @Input() video: string | undefined;

  @ViewChild('videoElement') videoElement : ElementRef;

  group:string;

  constructor(elem: ElementRef,
              private eventManagerService: EventManagerService,
              private videoService: VideoService)
  {
    this.group = elem.nativeElement.tagName.toLowerCase();
  }

  /**
   * Se ejecuta cuando se inicializa el componente
   */
  ngOnInit(): void
  {
    this.eventManagerService.unsubscribeGroupEvent(this.group);
    this.eventManagerService.subscribeGroupEvent<void>(this.group, WincoEvents.STOP_VIDEO, () => this.stop());
  }

  ngOnDestroy()
  {
    this.eventManagerService.unsubscribeGroupEvent(this.group);
  }

  /**
   * Reproduce el vídeo
   */
  play()
  {
    if(this.videoElement)
      this.videoElement.nativeElement.play();
  }

  /**
   * Detiene la reproducción de vídeo
   */
  stop()
  {
    if(this.videoElement)
      this.videoElement.nativeElement.pause();
  }
}
